import React from "react";

function BS4_Alerts() {
  return (
    <div>
      <h1>BS4_Alerts Component</h1>
      <p>This is the BS4_Alerts tutorial page content.</p>
    </div>
  );
}

export default BS4_Alerts;
